module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"homeIndex":{"subtext":"Get peace of mind with the best value home insurance.","save":"Ready to save up to €500 annually?","search":{"label":"Are you ready to get the best home insurance for you?"},"searchButton":"Get started"}}}')
  delete Component.options._Ctor
}
